// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { openBackOrdersStyles } from "@steiner/App/Widgets/OpenBackOrders/OpenBackOrders";
import Copy from "@steiner/XDL/Icons/Copy";
import Print from "@steiner/XDL/Icons/Print";
import Subscribe from "@steiner/XDL/Icons/Subscribe";
import UnSubscribe from "@steiner/XDL/Icons/UnSubscribe";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

openBackOrdersStyles.upperSection = {
    css: css`
        display: flex;
        margin-bottom: 16px;
        justify-content: space-between;
        gap: 16px;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
        }
    `,
};

openBackOrdersStyles.notifyMessage = {
    css: css`
        margin-bottom: 0;
    `,
};

openBackOrdersStyles.descriptionHeaderCell = {
    css: css`
        ${xScreen("gt", "md")} {
            min-width: 400px;
        }
    `,
};

openBackOrdersStyles.descriptionCell = {
    css: css`
        ${xScreen("gt", "lg")} {
            max-width: 400px;
            white-space: normal;
        }
    `,
};

openBackOrdersStyles.actionContainer = {
    css: css`
        display: flex;
        margin-left: 20px;
        padding-left: 20px;
        border-left: 1px solid ${color("common.white")};

        ${xScreen("lte", "sm")} {
            border-left: 0;
            padding-left: 0;
            margin-left: 0;
        }

        @media print {
            display: none;
        }
    `,
};

openBackOrdersStyles.exportLink = {
    color: "common.white",
    icon: {
        iconProps: {
            src: Copy,
            size: 15,
            color: "common.white",
        },
    },
    typographyProps: {
        color: "common.white",
        size: 14,
    },
    css: css`
        padding-right: 20px;
        & > ${IconWrapper} {
            &,
            svg,
            path {
                opacity: 1;
            }
        }
        &:not([disabled]):hover {
            & > ${TypographyStyle} {
                color: ${color("common.white")};
                text-decoration: underline;
            }
            & > ${IconWrapper} {
                color: ${color("common.white")};
            }
        }
    `,
};

openBackOrdersStyles.printLink = {
    color: "common.white",
    icon: {
        iconProps: {
            src: Print,
            size: 15,
            color: "common.white",
        },
    },
    typographyProps: {
        color: "common.white",
        size: 14,
        css: css`
            &:hover {
                color: ${color("common.white")};
                text-decoration: underline;
            }
        `,
    },
    css: css`
        & > ${IconWrapper} {
            &,
            svg,
            path {
                opacity: 1;
            }
        }
        &:not([disabled]):hover {
            & > ${TypographyStyle} {
                color: ${color("common.white")};
                text-decoration: underline;
            }
            & > ${IconWrapper} {
                color: ${color("common.white")};
            }
        }
    `,
};

openBackOrdersStyles.tableCounterStyles = {
    rangeAndNavigationContainer: {
        css: css`
            ${xScreen("lte", "sm")} {
                margin-left: 0;
                justify-content: space-between;
                flex-wrap: wrap;
                width: 100%;
                gap: 10px;
            }
        `,
    },
};

openBackOrdersStyles.pagination = {
    cssOverrides: {
        pagination: css`
            @media print {
                display: none;
            }
        `,
    },
};

openBackOrdersStyles.loadingStyle = {
    css: css`
        @media print {
            display: block !important;
        }
    `,
};

openBackOrdersStyles.subscribeLink = {
    typographyProps: {
        size: fontConfig.fontSize.small,
        lineHeight: fontConfig.lineHeight.small,
    },
    icon: {
        iconProps: {
            src: Subscribe,
        },
    },
    css: css`
        align-self: flex-start;
        margin-top: 5px;

        ${xScreen("lte", "xs")} {
            align-self: end;
            margin-top: 0;
        }
    `,
};

openBackOrdersStyles.unSubscribeLink = {
    typographyProps: {
        size: fontConfig.fontSize.small,
        lineHeight: fontConfig.lineHeight.small,
    },
    icon: {
        iconProps: {
            src: UnSubscribe,
        },
    },
    css: css`
        align-self: flex-start;
        margin-top: 5px;

        ${xScreen("lte", "xs")} {
            align-self: end;
            margin-top: 0;
        }
    `,
};

openBackOrdersStyles.sendSheetAsEmailFormContainer = {
    css: css`
        max-width: 370px;
        width: 100%;

        form {
            display: flex;
            align-items: flex-start;
            gap: 8px;
        }

        ${xScreen("lte", "xs")} {
            max-width: 100%;
        }
    `,
};
